import React from 'react';

export const AppIcon: { [key: string]: React.ReactNode } = {
  "Core": (
    <svg viewBox="0 0 24 24" width="16" height="16">
      <path fill="currentColor" d="M12 2l9 5v10l-9 5-9-5V7z" />
    </svg>
  ),
  "Data Intelligence": (
    <svg viewBox="0 0 24 24" width="16" height="16">
      <circle cx="12" cy="12" r="3" fill="currentColor" />
      <circle cx="6" cy="6" r="2" fill="currentColor" />
      <circle cx="18" cy="6" r="2" fill="currentColor" />
      <circle cx="6" cy="18" r="2" fill="currentColor" />
      <circle cx="18" cy="18" r="2" fill="currentColor" />
      <path stroke="currentColor" strokeWidth="1.5" fill="none" d="M12 9v3m0 0v3m0-3h3m-3 0H9m3-6l-4-3m4 3l4-3m-4 15l-4 3m4-3l4 3" />
    </svg>
  ),
  "Analytics": (
    <svg viewBox="0 0 24 24" width="16" height="16">
      <path fill="currentColor" d="M3 13l4-8 6 14 4-8 4 10" />
    </svg>
  ),
  "Planning": (
    <svg viewBox="0 0 24 24" width="16" height="16">
      <path fill="currentColor" d="M3 4h18v4H3zM3 10h10v10H3zM15 10h6v10h-6z" />
    </svg>
  ),
  "Cost": (
    <svg viewBox="0 0 24 24" width="16" height="16">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" fill="none" />
      <path fill="currentColor" d="M12 6v12M9 9h6v6H9z" />
    </svg>
  ),
  "Layout Studio": (
    <svg viewBox="0 0 24 24" width="16" height="16">
      <path stroke="currentColor" strokeWidth="2" fill="none" d="M4 6h16M4 12h16M4 18h16M8 6v12M16 6v12" />
    </svg>
  ),
  "3D Visualization": (
    <svg viewBox="0 0 24 24" width="16" height="16">
      <path fill="currentColor" d="M12 2l9 5v10l-9 5-9-5V7z" opacity="0.5" />
      <path fill="currentColor" d="M12 7l5 3v6l-5 3-5-3v-6z" />
    </svg>
  ),
};

export const TypeIcon: { [key: string]: React.ReactNode } = {
  Project: (
    <svg viewBox="0 0 24 24" width="16" height="16">
      <path fill="currentColor" d="M3 4h18v4H3zM3 10h10v10H3zM15 10h6v10h-6z" />
    </svg>
  ),
  System: (
    <svg viewBox="0 0 24 24" width="16" height="16">
      <path fill="currentColor" d="M12 2l9 5v10l-9 5-9-5V7z" />
    </svg>
  ),
  Model: (
    <svg viewBox="0 0 24 24" width="16" height="16">
      <path fill="currentColor" d="M12 2l9 5v10l-9 5-9-5V7z" opacity="0.7" />
      <path fill="currentColor" d="M12 7l5 3v6l-5 3-5-3v-6z" />
    </svg>
  ),
  Tag: (
    <svg viewBox="0 0 24 24" width="16" height="16">
      <path fill="currentColor" d="M3 12l9-9 9 9-9 9z" />
    </svg>
  ),
  Isometric: (
    <svg viewBox="0 0 24 24" width="16" height="16">
      <path stroke="currentColor" strokeWidth="2" fill="none" d="M3 8l9-5 9 5v8l-9 5-9-5z" />
    </svg>
  ),
  Document: (
    <svg viewBox="0 0 24 24" width="16" height="16">
      <path fill="none" stroke="currentColor" strokeWidth="2" d="M6 2h9l5 5v15H6zM14 2v6h6" />
    </svg>
  ),
  Dashboard: (
    <svg viewBox="0 0 24 24" width="16" height="16">
      <path fill="currentColor" d="M3 13l4-8 6 14 4-8 4 10" />
    </svg>
  ),
  Report: (
    <svg viewBox="0 0 24 24" width="16" height="16">
      <path fill="currentColor" d="M4 4h16v12H4zM2 18h20v2H2z" />
    </svg>
  ),
  Activity: (
    <svg viewBox="0 0 24 24" width="16" height="16">
      <path fill="currentColor" d="M3 4h18v4H3zM3 10h10v10H3zM15 10h6v10h-6z" />
    </svg>
  ),
  Estimation: (
    <svg viewBox="0 0 24 24" width="16" height="16">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" fill="none" />
      <path fill="currentColor" d="M12 6v12M9 9h6v6H9z" />
    </svg>
  ),
  "Change Impact": (
    <svg viewBox="0 0 24 24" width="16" height="16">
      <circle cx="12" cy="12" r="9" fill="currentColor" opacity=".1" />
      <path stroke="currentColor" strokeWidth="2" fill="none" d="M12 7v10m-5-5h10" />
    </svg>
  ),
  PFD: (
    <svg viewBox="0 0 24 24" width="16" height="16">
      <path stroke="currentColor" strokeWidth="2" fill="none" d="M4 6h16M4 12h16M4 18h16M8 6v12M16 6v12" />
    </svg>
  ),
  "Data Pipeline": (
    <svg viewBox="0 0 24 24" width="16" height="16">
      <path stroke="currentColor" strokeWidth="2" fill="none" d="M3 12h18M12 3v18" />
    </svg>
  ),
  User: (
    <svg viewBox="0 0 24 24" width="16" height="16">
      <path fill="currentColor" d="M12 12a5 5 0 1 0-5-5 5 5 0 0 0 5 5Zm-8 9a8 8 0 1116 0H4z" />
    </svg>
  ),
};
